import AxiosInstance from "./api";

export const BonusPaymentTableService = {
  getPaginate: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get("/private/bonus-table", {
      params: query,
    });
  },
  getById: async (id) => {
    return await AxiosInstance.get("/private/bonus-table/" + id);
  },
  create: async (payload) => {
    return await AxiosInstance.post("/private/bonus-table", payload);
  },
  update: async (id, payload) => {
    return await AxiosInstance.patch("/private/bonus-table/" + id, payload);
  },
  delete: async (id) => {
    return await AxiosInstance.delete("/private/bonus-table/" + id);
  },
};
